import { stepGroups } from '../data/journey';
import type { Answers, StepGroup } from '../types/application';

export function isStepVisible(stepId: string, a: Answers): boolean {
  if (stepId === 'stage') return a.goal === 'purchase';
  if (stepId === 'address') return a.goal === 'refinance' || a.propertyStage !== 'looking';
  if (stepId === 'pay') return a.employmentType === 'w2' || a.employmentType === 'self';
  if (stepId === 'employer') return a.employmentType !== 'none' && a.employmentType !== 'retired';
  if (stepId === 'decl-transaction') return a.goal === 'purchase';
  return true;
}

export function visibleGroups(a: Answers): StepGroup[] {
  return stepGroups.map((g) => ({ ...g, steps: g.steps.filter((s) => isStepVisible(s.id, a)) }));
}

export function flatSteps(a: Answers): string[] {
  return visibleGroups(a).flatMap((g) => g.steps.map((s) => s.id));
}

export function groupForStep(stepId: string, a: Answers): StepGroup | undefined {
  return visibleGroups(a).find((g) => g.steps.some((s) => s.id === stepId));
}

export function neighbors(stepId: string, a: Answers): { prev?: string; next?: string } {
  const steps = flatSteps(a);
  const i = steps.indexOf(stepId);
  return { prev: i > 0 ? steps[i - 1] : undefined, next: i >= 0 && i < steps.length - 1 ? steps[i + 1] : undefined };
}

export function progressPercent(completed: string[], a: Answers): number {
  const steps = flatSteps(a);
  const done = steps.filter((s) => completed.includes(s)).length;
  return Math.round((done / steps.length) * 100);
}

export function minutesLeft(completed: string[], a: Answers): number {
  const steps = flatSteps(a);
  return Math.max(1, steps.filter((s) => !completed.includes(s)).length);
}
